import request from "@/utils/request.js";
// import { message } from 'ant-design-vue'
const baseurl = process.env.VUE_APP_BASE_URL;
// 统计图表
export function getchartData(params) {
  return request({
    baseURL: baseurl.replace("/api", ""),
    url: "/bpm/api/statistics/school/v1/report",
    method: "POST",
    data: params,
  });
}
// 获取游客id
const code = process.env.VUE_APP_BASE_CODE;
export function getTenantId() {
  return request({
    baseURL: baseurl.replace("/api", ""),
    url: `/bpm/uc/tenantManage/v1/getTenantByCode?code=${code}`,
    method: "GET",
  });
}
// 获取token
export function authentication(id) {
  return request({
    url: `/auth?tenantId=${id}`,
    data: {
      username: "yk_scnu",
      password: "MTIzNDU2",
    },
    method: "POST",
  });
}

// 获取同比增长
export function getGrowthData(params) {
  return request({
    baseURL: baseurl.replace("/api", ""),
    url: "/bpm/form/dataTemplate/v1/listJson",
    method: "POST",
    data: params,
  });
}
